import { ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CognitoNewPasswordRequiredError } from '../../services/cognito.service';

@Component({
  selector: 'app-login',
  imports: [FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  protected username = '';
  protected password = '';
  protected newPassword = '';
  protected confirmNewPassword = '';
  protected newPasswordRequired = false;
  protected errorMessage = '';
  protected loading = false;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  protected submit(): void {
    if (!this.username.trim() || !this.password) {
      this.errorMessage = 'Identifiant et mot de passe requis.';
      this.cdr.detectChanges();
      return;
    }

    if (this.newPasswordRequired) {
      this.submitNewPassword();
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    this.cdr.detectChanges();
    this.authService.login(this.username.trim(), this.password).subscribe({
      next: () => {
        this.loading = false;
        this.cdr.detectChanges();
        this.router.navigate(['/intranet']);
      },
      error: (err: any) => {
        const message = err instanceof Error ? err.message : String(err ?? '');
        if (
          err instanceof CognitoNewPasswordRequiredError ||
          message.includes('CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') ||
          message.toLowerCase().includes('nouveau mot de passe requis')
        ) {
          this.newPasswordRequired = true;
          this.errorMessage = 'Nouveau mot de passe requis. Merci de definir un nouveau mot de passe pour terminer la connexion.';
          this.loading = false;
          this.cdr.detectChanges();
          return;
        }

        this.errorMessage =
          err instanceof Error ? err.message : 'Erreur de connexion.';
        console.error('Erreur de connexion:', err);
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }

  private submitNewPassword(): void {
    if (!this.newPassword || !this.confirmNewPassword) {
      this.errorMessage = 'Veuillez renseigner le nouveau mot de passe et sa confirmation.';
      this.cdr.detectChanges();
      return;
    }

    if (this.newPassword !== this.confirmNewPassword) {
      this.errorMessage = 'La confirmation du nouveau mot de passe ne correspond pas.';
      this.cdr.detectChanges();
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    this.cdr.detectChanges();

    this.authService.completeNewPassword(this.newPassword, this.username.trim()).subscribe({
      next: () => {
        this.loading = false;
        this.newPasswordRequired = false;
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.cdr.detectChanges();
        this.router.navigate(['/intranet']);
      },
      error: (err: unknown) => {
        this.errorMessage = err instanceof Error ? err.message : 'Erreur lors de la mise a jour du mot de passe.';
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }
}
